import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Table } from "reactstrap";

// Rol çevirisi fonksiyonu
const translateRole = (role) => {
    switch (role) {
        case "ROLE_SUPER_ADMIN":
            return "Süper Yönetici";
        case "ROLE_COMPANY_ADMIN":
            return "Firma Yöneticisi";
        case "ROLE_COMPANY_ACCOUNTANT":
            return "Firma Muhasebecisi";
        case "ROLE_COMPANY_SALESPERSON":
            return "Firma Plasiyer";
        case "ROLE_COMPANY_CASHIER":
            return "Firma Kasa Sorumlusu";
        case "ROLE_ACCOUNT_ADMIN":
            return "Cari/Bayi Yönetici";
        case "ROLE_ACCOUNT_ACCOUNTANT":
            return "Cari/Bayi Muhasebe";
        case "ROLE_USER":
            return "Kullanıcı";
        case "ROLE_MODERATOR":
            return "Moderatör";
        default:
            return role.replace(/^ROLE_/, "");
    }
};

/**
 * UserDetailModal – Kullanıcı detaylarını gösteren modal
 *
 * Props
 * @param {boolean} isOpen    – Modal açık mı?
 * @param {Function} toggle   – Modal'ı kapat/aç
 * @param {object|null} user  – Gösterilecek kullanıcı nesnesi
 */
const UserDetailModal = ({ isOpen, toggle, user }) => {
    if (!user) return null;

    // Firma kullanıcısı mı kontrol et
    const isCompanyUser = user.roles?.some(role =>
        role === "ROLE_SUPER_ADMIN" ||
        role === "ROLE_COMPANY_ADMIN" ||
        role === "ROLE_COMPANY_ACCOUNTANT" ||
        role === "ROLE_COMPANY_SALESPERSON" ||
        role === "ROLE_COMPANY_CASHIER"
    );

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Kullanıcı Detayları</ModalHeader>
            <ModalBody>
                <Table bordered responsive>
                    <tbody>
                    <tr>
                        <th>ID</th>
                        <td>{user.id}</td>
                    </tr>
                    <tr>
                        <th>Ad Soyad</th>
                        <td>{user.username}</td>
                    </tr>
                    <tr>
                        <th>E-posta</th>
                        <td>{user.email}</td>
                    </tr>
                    <tr>
                        <th>Telefon Numarası</th>
                        <td>{user.phoneNumber}</td>
                    </tr>
                    <tr>
                        <th>Firma Kodu</th>
                        <td>{user.companyCode || "-"}</td>
                    </tr>
                    {/* Cari kodu sadece firma kullanıcısı değilse göster */}
                    {!isCompanyUser && (
                        <tr>
                            <th>Cari/Bayi Kodu</th>
                            <td>{user.accountCode || "-"}</td>
                        </tr>
                    )}
                    <tr>
                        <th>Roller</th>
                        <td>{user.roles?.map(translateRole).join(", ")}</td>
                    </tr>
                    <tr>
                        <th>Aktif</th>
                        <td>{user.enabled ? "Evet" : "Hayır"}</td>
                    </tr>
                    <tr>
                        <th>2FA Etkin</th>
                        <td>{user.twoFaEnabled ? "Evet" : "Hayır"}</td>
                    </tr>
                    <tr>
                        <th>Başarısız Giriş Denemeleri</th>
                        <td>{user.failedAttempts}</td>
                    </tr>
                    <tr>
                        <th>Oluşturulma Tarihi</th>
                        <td>{new Date(user.createdAt).toLocaleString("tr-TR")}</td>
                    </tr>
                    <tr>
                        <th>Güncellenme Tarihi</th>
                        <td>{user.updatedAt
                            ? new Date(user.updatedAt).toLocaleString("tr-TR")
                            : "-"}
                        </td>
                    </tr>
                    </tbody>
                </Table>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Kapat</Button>
            </ModalFooter>
        </Modal>
    );
};

export default UserDetailModal;